import { useEffect, useState } from 'react';
import { getPage } from '@/services/copyright/copyright.service';
import type { CopyrightPage } from '@edwin-group/people-graphql';
import DefaultContentTemplatePage from '../default-content-template';

const CopyrightPageComponent = () => {
  const [page, setPage] = useState<CopyrightPage | null>(null);

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      setLoading(true);

      const pageResponse = await getPage();

      setPage(pageResponse.page);
      setLoading(false);
    })();
  }, []);

  const template = page?.DefaultContentTemplate || null;

  if (loading) {
    return null;
  }

  return (
    <>
      <DefaultContentTemplatePage template={template} title={page?.title || 'Back to the Homepage'} />
    </>
  );
};

export default CopyrightPageComponent;
